const childRoutes = (prop) => [
    {
        path: 'application-list',
        name: prop + '.application_list',
        meta: { auth: true },
        redirect: to => ({ name: prop + '.patient_list', query: to.query })
    },
    {
        path: 'recommended-list',
        name: prop + '.recommended_list',
        meta: { auth: true },
        redirect: to => ({ name: prop + '.patient_list', query: to.query })
    },
    {
        path: 'approved-list',
        name: prop + '.approved_list',
        meta: { auth: true },
        redirect: to => ({ name: prop + '.patient_list', query: to.query })
    },
    {
        path: 'patient-list',
        name: prop + '.patient_list',
        meta: { auth: true },
        component: () => import('../pages/patient-list/List.vue'),
        comment: 'added as per request from prabir vai. other patient lists are not needed. 20261028'
    },
    {
        path: 'center-change-request-list',
        name: prop + '.center_change_request_list',
        meta: { auth: true },
        component: () => import('../pages/center-change-request-list/List.vue')
    },
    {
        path: 'awareness-info',
        name: prop + '.awareness_info',
        meta: { auth: true },
        component: () => import('../pages/awareness-info/List.vue')
    },
    {
        path: 'patient-report',
        name: prop + '.patient_report',
        meta: { auth: true },
        component: () => import('../pages/patient-report/List.vue')
    }
]

const routes = [{
    path: '/awareness-event-service/info-management-system',
    name: 'awareness_event_service.info_management_system',
    component: () => import('@/layouts/AwarenessEventLayout.vue'),
    meta: { auth: true },
    children: childRoutes('awareness_event_service.info_management_system')
}]

export default routes
